const getNodePath = (nodeData, root) => {
  let pa = [];
  const recurse = (data, node, pathArr) => {
    pathArr.push(node);
    if (node.id === data.id) {
      pa = pathArr.concat([]);
      return;
    }
    if (node.children && node.children.length > 0) {
      for (let i = 0; i < node.children.length; i += 1) {
        recurse(data, node.children[i], pathArr);
      }
      pathArr.pop();
    } else {
      pathArr.pop();
    }
  };
  recurse(nodeData, root, pa);
  return pa;
};

const getExtendedNodePath = (root) => {
  const result = [];
  const pa = [];
  const recurse = (node, pathArr) => {
    if (node.code !== '') {
      pathArr.push(node);
    }
    if (node.children && node.children.length > 0) {
      for (let i = 0; i < node.children.length; i += 1) {
        recurse(node.children[i], pathArr);
      }
      pathArr.pop();
    } else {
      result.push(pathArr
        .map(item => ({
          code: item.code,
          name: item.name,
        })));
      pathArr.pop();
    }
  };
  recurse(root, pa);
  return result;
};

export { getNodePath, getExtendedNodePath };



// WEBPACK FOOTER //
// ./src/util/treeUtils.js